module.exports = __webpack_public_path__ + "img/slider3.c4713eea.jpg";